import React from "react";
import Header from "../components/header/Header";
import MapContainer from "../components/map/MapContainer";
import Footer from "../components/footer/Footer";

const Map = () => {
  return (
    <div>
        <Header />
        <MapContainer />
        <Footer/>
    </div>
    );
};

export default Map;
